import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import styles from "../../../../assets/styles/componentStyles/billingStyles/billing.module.scss";

const InvoiceCell = ({ url }: { url?: string }) => {
    if (!url) {
        return <>-</>;
    }

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.invoiceLink}
            onClick={(event) => event.stopPropagation()}
        >
            <VisibilityOutlinedIcon sx={{ fontSize: 16 }} />
            Invoice
        </a>
    );
};

export default InvoiceCell;
